<template>
  <p class="report__card-info-text">{{ text }}</p>
</template>
<script>
export default {
  props: {
    text: String,
  },
};
</script>

<style scoped>
.report__card-info-text {
  margin-bottom: 0;
  color: #666666;
  font-family: "DM Sans";
}
</style>
